// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopI18nControllerGetMessagesData } from './EshopI18nControllerGetMessagesData.gen';
import type { EshopI18nControllerGetMessagesErrors } from './EshopI18nControllerGetMessagesErrors.gen';
import type { EshopI18nControllerGetMessagesResponses } from './EshopI18nControllerGetMessagesResponses.gen';
import type { EshopI18nControllerGetSupportedLocalesData } from './EshopI18nControllerGetSupportedLocalesData.gen';
import type { EshopI18nControllerGetSupportedLocalesErrors } from './EshopI18nControllerGetSupportedLocalesErrors.gen';
import type { EshopI18nControllerGetSupportedLocalesResponses } from './EshopI18nControllerGetSupportedLocalesResponses.gen';
import type { Options } from './Options.gen';

export class EshopI18NController {
    /**
     * Get all supported localizations for the e-shop frontend.
     */
    public static getSupportedLocales<ThrowOnError extends boolean = false>(options?: Options<EshopI18nControllerGetSupportedLocalesData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopI18nControllerGetSupportedLocalesResponses, EshopI18nControllerGetSupportedLocalesErrors, ThrowOnError>({ url: '/api/eshop/i18n/supported-locales', ...options });
    }
    
    /**
     * Get all localized messages for the e-shop frontend.
     */
    public static getMessages<ThrowOnError extends boolean = false>(options: Options<EshopI18nControllerGetMessagesData, ThrowOnError>) {
        return (options.client ?? client).get<EshopI18nControllerGetMessagesResponses, EshopI18nControllerGetMessagesErrors, ThrowOnError>({ url: '/api/eshop/i18n/messages', ...options });
    }
}
